<nz-tabs [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)" nzSize="large" style="height: 100vh;">
  <nz-tab nzTitle="Work" i18n-nzTitle>
    <app-work-batches></app-work-batches>
  </nz-tab>
  <nz-tab nzTitle="Sort &amp; filter" i18n-nzTitle>
    @if (selectedTabIndex === 1) {
      <app-sort-filter-work-batches></app-sort-filter-work-batches>
    }
  </nz-tab>
  @if (authState.hasRole(UserRole.Admin)) {
    <nz-tab nzTitle="Debug" i18n-nzTitle>
      @if (selectedTabIndex === 2) {
        <app-debug></app-debug>
      }
    </nz-tab>
  }
</nz-tabs>
